/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {FeedbackResponse} from '../models/FeedbackResponse';
import type {ReasonResponse} from '../models/ReasonResponse';
import type {SubmitFeedbackRequest} from '../models/SubmitFeedbackRequest';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class FeedbackService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Record a piece of AI feedback for the authenticated user.
   * @returns FeedbackResponse Created
   * @throws ApiError
   */
  public feedbackSubmit({
    requestBody,
  }: {
    requestBody: SubmitFeedbackRequest;
  }): CancelablePromise<FeedbackResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/feedback',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * Get the active reason chips for a feature (used to render the feedback widget).
   * @returns ReasonResponse OK
   * @throws ApiError
   */
  public feedbackGetReasons({
    feature,
  }: {
    /**
     * The AI feature key (e.g. "create-file").
     */
    feature?: string;
  }): CancelablePromise<Array<ReasonResponse>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/feedback/reasons',
      query: {
        feature: feature,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal Server Error`,
      },
    });
  }
}
